import { client } from "@/tina/__generated__/client";

/**
 * Returns the global Tina JSON record.
 *
 * Uses the generated Tina client directly so this module can be imported
 * from `utils` without a circular dependency.
 *
 * Note: We intentionally do not use `react`'s `cache()` here. Tina CLI
 * bundles app code (e.g. `utils` via field components), and its React
 * resolution does not expose `cache` in that context.
 */
export async function getGlobalRecord() {
  try {
    const result = await client.queries.global({
      relativePath: "global.json",
    });
    return result?.data?.global as any;
  } catch (error) {
    console.error("[seo/global] Failed to load global record:", error);
    return null;
  }
}
